export { default } from './ValuePropositions';
export * from './ValuePropositions';